import { getCurrencySymbol } from './get-currency-symbol.utils';
import { getMoneyBaseUnit } from './get-money-base-unit.utils';

export const getMoneyAsString = (currency: string, valueInSubunits: number) => {
  return `${getCurrencySymbol(currency)}${getMoneyBaseUnit(valueInSubunits, true).toFixed(2)}`;
};
